import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import Navbar from '../../components/Navbar';
import { POSTS } from './posts';

const imgUrl = (slug) => `https://images.unsplash.com/${slug}?w=900&h=600&fit=crop&auto=format&q=70`;

export default function BlogIndex() {
  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white" data-testid="blog-index">
      <Navbar />
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 pt-20 pb-24 relative">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] rounded-full bg-[#FF6B4A]/10 blur-[120px] pointer-events-none" />

        {/* Header */}
        <div className="relative text-center mb-16">
          <p className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#FFD93D] mb-4">DIS2ORT Blog</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight uppercase leading-[0.95] mb-5">
            INSIDE THE<br />
            <span className="italic bg-gradient-to-r from-[#FF6B4A] to-[#E040A0] bg-clip-text text-transparent">CREATOR STUDIO.</span>
          </h1>
          <p className="text-sm lg:text-base text-white/55 max-w-xl mx-auto">Honest comparisons, prompt techniques, and the future of AI media — straight from the team that runs 150 models in one tab.</p>
        </div>

        {/* Posts */}
        <div className="relative grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="blog-grid">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group rounded-2xl overflow-hidden bg-white/[0.03] border border-white/[0.06] hover:border-white/[0.15] transition-colors">
              <div className="aspect-[3/2] overflow-hidden">
                <img src={imgUrl(p.coverImage)} alt={p.title} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.2em] text-white/40 uppercase mb-3">
                  <span className="px-2 py-0.5 rounded-full bg-[#FF6B4A]/20 text-[#FF6B4A]">{p.tag}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {p.readTime}</span>
                </div>
                <h2 className="font-display text-xl font-bold tracking-tight text-white mb-2 leading-tight line-clamp-2">{p.title}</h2>
                <p className="text-xs text-white/60 leading-relaxed line-clamp-3 mb-3">{p.excerpt}</p>
                <div className="flex items-center gap-1 text-[10px] font-bold tracking-[0.2em] text-[#FF6B4A] uppercase group-hover:text-[#FFD93D] transition-colors">
                  Read <ArrowRight className="w-3 h-3" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
